import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=87bb01a4&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=87bb01a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bb01a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bb01a4')) {
      api.createRecord('87bb01a4', component.options)
    } else {
      api.reload('87bb01a4', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=87bb01a4&scoped=true", function () {
      api.rerender('87bb01a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/middle-ware/Index.vue"
export default component.exports